// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs_root__29DBD","crumb":"Breadcrumbs_crumb__0XlGj","icon":"Breadcrumbs_icon__k9IIG","inverted":"Breadcrumbs_inverted__hcScK"};